import React, { useEffect } from 'react';
import ErrorEnrollAchOut from '../../BankTransfer/components/ErrorEnrollAchOut';
import { trackMixPanel } from '../../../services/mixpanel.service';

const SendMoneyLimitsError = ({ enrollErrorData }: { enrollErrorData: { errCode: number, errMsg: string } }) => {
  useEffect(() => {
    trackMixPanel('View Move Money Limit Error Screen', {
      errorMessage: enrollErrorData?.errMsg,
      ErrorCode: enrollErrorData?.errCode,
      Flow: 'plaid transfer out',
    });
  }, []);
  return (
    <div className='flex justify-center'>
      <ErrorEnrollAchOut enrollErrorData={enrollErrorData} />
    </div>
  );
};

export default SendMoneyLimitsError;
